import React, { useState, useCallback, useEffect } from "react"; // <<< Add useCallback, useEffect >>>
import axios from "axios";
import '../styles/AdminPage.css';
import UserSection from '../sections/admin/UserSection';
import CountersSection from '../sections/admin/CountersSection';
import KiosksSection from '../sections/admin/KiosksSection';
import ServicesSection from '../sections/admin/ServicesSection';
import LicensesSection from '../sections/admin/LicensesSection';
import TenantsSection from '../sections/admin/TenantsSection';
//import CounterServiceSection from '../sections/admin/CounterServiceSection';
import EODCleanupSection from '../sections/admin/EODCleanupSection';

// ... (imports for sub-sections)

// Consistent BASE_URL (assuming you fixed your .env file)
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function AdminPage({ user, onLogout }) { 
  const [activeSection, setActiveSection] = useState('users');
  const [users, setUsers] = useState([]);
  const [counters, setCounters] = useState([]);
  const [kiosks, setKiosks] = useState([]);
  const [services, setServices] = useState([]);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [licenses, setLicenses] = useState([]);
  const [tenants, setTenants] = useState([]);

  // Log the 'users' state whenever it changes in AdminPage
  useEffect(() => {
    console.log("AdminPage State Change: 'users' state updated to:", users);
    console.log("AdminPage State Change: 'users' state length:", users.length);
  }, [users]); // This useEffect runs every time 'users' state is updated

  const fetchAll = useCallback(async () => {
    if (!user || !user.tenant_id) {
        setMsg({ type: 'error', text: 'Admin user not logged in or tenant ID missing.' });
        return;
    }
    const headers = {
      'X-User-Id': user.id,
      'X-User-Role': user.role,
      'X-Tenant-Id': user.tenant_id
    };
    try {
      const [usersRes, countersRes, kiosksRes, servicesRes, licensesRes, tenantsRes] = await Promise.all([
        axios.get(`${BASE_URL}/api/users`, { headers }),
        axios.get(`${BASE_URL}/api/counters`, { headers }),
        axios.get(`${BASE_URL}/api/kiosks`, { headers }),
        axios.get(`${BASE_URL}/api/services`, { headers }),
        axios.get(`${BASE_URL}/api/licenses`, { headers }),
        axios.get(`${BASE_URL}/api/tenants`, { headers }),
      ]);
      setUsers(usersRes.data);
      setCounters(countersRes.data);
      setKiosks(kiosksRes.data);
      setServices(servicesRes.data);
      setLicenses(licensesRes.data);
      setTenants(tenantsRes.data);
      setMsg({ type: '', text: '' });
    } catch (error) {
      setMsg({ type: 'error', text: `Failed to fetch data: ${error.message}` });
      console.error("Error fetching all admin data:", error);
    }
  }, [user]);

  // Initial fetch on component mount (and when user changes)
  React.useEffect(() => {
    fetchAll(); 
  }, [fetchAll]); // <<< Now, fetchAll itself is a stable dependency >>>

  // Map section names to components
  const sectionComponents = {
    users: UserSection,
    counters: CountersSection,
    kiosks: KiosksSection,
    services: ServicesSection,
    licenses: LicensesSection,
    tenants: TenantsSection,
    eod_cleanup: EODCleanupSection, // <<< ADD THIS LINE >>>  
    //'counter-service': CounterServiceSection, // Use a string key with hyphen for URL/display
  };

  const ActiveComponent = sectionComponents[activeSection];


  return (
    <div className="admin-container">
      <header className="admin-header">
        Admin Panel
        {/* --- LOGOUT BUTTON --- */}
        {onLogout && ( // Only show if onLogout prop is provided
          <button 
            onClick={onLogout} 
            className="admin-button admin-button-danger">
            Logout
          </button>
        )}
        {/* --- END LOGOUT BUTTON --- */}
      </header>
      <nav className="admin-navbar">
        <button onClick={() => setActiveSection('users')} className={activeSection === 'users' ? 'active' : ''}>Users</button>
        <button onClick={() => setActiveSection('counters')} className={activeSection === 'counters' ? 'active' : ''}>Counters</button>
        <button onClick={() => setActiveSection('kiosks')} className={activeSection === 'kiosks' ? 'active' : ''}>Kiosks</button>
        <button onClick={() => setActiveSection('services')} className={activeSection === 'services' ? 'active' : ''}>Services</button>
        <button onClick={() => setActiveSection('licenses')} className={activeSection === 'licenses' ? 'active' : ''}>Licenses</button>
        {(user?.role === 'vendor_admin' || user?.role === 'VENDOR_ADMIN') && (
          <button onClick={() => setActiveSection('tenants')} className={activeSection === 'tenants' ? 'active' : ''}>Tenants</button>
        )}
        <button onClick={() => setActiveSection('eod_cleanup')} className={activeSection === 'eod_cleanup' ? 'active' : ''}>EOD Cleanup</button>
        {/* Add Logout button here later */}
      </nav>

      <main className="admin-content-area">
        {msg.text && (
          <div className={`admin-message ${msg.type}`}>
            {msg.text}
          </div>
        )}
        <ActiveComponent
          user={user} // User object is still passed
          users={users} // <<< ADD THIS LINE >>>
          services={services}
          counters={counters}
          kiosks={kiosks}
          licenses={licenses}
          tenants={tenants}
          setMsg={setMsg}
          fetchAll={fetchAll}
          // No tenantId prop here anymore
        />
      </main>
    </div>
  );
}